import { Component } from '@angular/core';
import { RoutingState } from './shared/services/RoutingState';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  constructor(routingState: RoutingState) {
    routingState.loadRouting();
  }
}
